<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <vs-row vs-justify="space-between" vs-align="center">
          <h3 class="card-title d-flex">App Notifications List</h3>
          <vs-button @click="addNew" icon="add" color="primary">Add Notification</vs-button>
        </vs-row>
        <vs-row vs-align="end" vs-justify="space-between">
          <div>
            <vs-col vs-lg="4">
              <vs-select :color="colorx" label="Language Filter" v-model="filter.language" @change="fetchAllNotifications()">
                <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" /> </vs-select
            ></vs-col>
            <vs-col vs-lg="3" style="margin-left: 4rem">
              <vs-select :color="colorx" label="Status Filter" v-model="filter.status" @change="fetchAllNotifications()">
                <vs-select-item value text="Select Status" disabled />
                <vs-select-item value="0" text="Inactive" />
                <vs-select-item value="1" text="Active" />
                <vs-select-item value="2" text="All" />
              </vs-select>
            </vs-col>
          </div>
          <vs-col vs-lg="1" vs-xs="0">
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th>Title</th>
            <th>Message</th>
            <th>Language</th>
            <th>Status</th>
            <th>Frequency</th>
            <th>Impressions</th>
            <th>Clicks</th>
            <th></th>
          </tr>
          <tr v-for="(item, index) in notifications" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.title }}</td>
            <td>{{ item.message }}</td>
            <td>{{ item.language }}</td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td>{{ item.cronRun }}</td>
            <td>{{ item.impressions }}</td>
            <td>{{ item.clicks }}</td>
            <td class="d-flex">
              <vs-button class="mr-1" icon="edit" @click="editingItem(item)" />
              <vs-button
                color="danger"
                icon="delete"
                @click="
                  deletePopup = true;
                  deleteId = item._id;
                "
              />
            </td>
          </tr>
        </table>
        <!-- opopup -->
        <vs-popup :title="this.editId ? 'Edit Notification' : 'Add Notification'" :active.sync="defaultalert" style="z-index: 30">
          <vs-col style="min-height: 500px" vs-lg="12" vs-xs="12" class="px-3">
            <!-- stage 1 -->
            <div style="display: flex; gap: 0.5cm; align-items: center">
              <!-- back to stage 1 -->
              <vs-button icon="arrow_back" color="primary" @click="handleBackClick" v-if="stage === 2 && isNew" />
              <!-- filter -->
              <vs-select
                v-if="isNew"
                :color="colorx"
                label="Category Language"
                @change="
                  if (!isNew) fetchAgainUsingLanguage(data.language);
                  fetchAllCategory();
                  fetchAllArticleCategories();
                  fetchAllGods();
                  fetchAllPromotedItems();
                "
                v-model="data.language"
                :disabled="stage === 2"
                icon="arrow_downward"
              >
                <vs-select-item value text="Choose language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
            </div>
            <!-- get notifaction type -->
            <vs-col vs-lg="12" vs-xs="12" v-if="stage === 1">
              <label class="vs-input--label mt-3">Select notification type</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="data.type"
                  placeholder="Select notification type"
                  :options="notificcationTypes"
                  :multiple="false"
                  @input="handleFetch($event)"
                />
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="stage === 1">
              <!-- combo-1-dailystatus -->
              <div v-if="data.type === 'daily-status'">
                <!-- ask for daily status -->
                <label class="vs-input--label mt-3">Select daily status</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.dailyStatus"
                    placeholder="Select daily status"
                    label="name"
                    track-by="_id"
                    :options="dailyStatuses"
                    :multiple="false"
                    @input="fetchPostsByCategory($event._id)"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('dailyStatus')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.dailyStatus"
                  />
                </div>
                <!-- switch to see if latest it ticked -->
                <div v-if="selectedOpts.dailyStatus" style="display: flex; flex-direction: column">
                  <label class="vs-input--label mt-2">Auto-assign latest</label>
                  <vs-switch v-model="selectedOpts.selectLatest" label="Latest" class="mt-3" />
                </div>
                <!-- ask for post -->
                <label class="vs-input--label mt-2" v-if="selectedOpts.dailyStatus">Select post</label>
                <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.dailyStatus">
                  <multiselect
                    v-model="selectedOpts.post"
                    placeholder="Select post"
                    label="name"
                    track-by="_id"
                    :options="fetchedPosts"
                    :multiple="false"
                    :disabled="selectedOpts.selectLatest"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('post')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.post"
                  />
                </div>
              </div>
              <!-- combo-2-article -->
              <div v-if="data.type === 'article'">
                <!-- ask for article category -->
                <label class="vs-input--label mt-3">Select article category</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.articleCat"
                    placeholder="Select article category"
                    label="name"
                    track-by="_id"
                    :options="fetchedArticleCats"
                    :multiple="false"
                    @input="fetchArticlesByCategory($event._id)"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('articleCat')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.articleCat"
                  />
                </div>
                <!-- switch to see if latest it ticked -->
                <div v-if="selectedOpts.articleCat" style="display: flex; flex-direction: column">
                  <label class="vs-input--label mt-2">Auto-assign latest</label>
                  <vs-switch v-model="selectedOpts.selectLatest" label="Latest" class="mt-3" />
                </div>
                <!-- ask for article -->
                <label class="vs-input--label mt-2" v-if="selectedOpts.articleCat">Select article</label>
                <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.articleCat">
                  <multiselect
                    v-model="selectedOpts.article"
                    placeholder="Select article"
                    label="name"
                    track-by="_id"
                    :options="fetchedArticles"
                    :multiple="false"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('article')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.article"
                  />
                </div>
              </div>
              <!-- combo-3-music -->
              <div v-if="data.type === 'music'">
                <!-- ask for god -->
                <label class="vs-input--label mt-3">Select god</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.god"
                    placeholder="Select god"
                    label="name"
                    track-by="_id"
                    :options="fetchedGods"
                    :multiple="false"
                    @input="fetchMusicByGod($event._id)"
                  />
                  <vs-button icon="clear" color="danger" @click="clearButton('god')" style="border-radius: 50%; z-index: 0" v-if="selectedOpts.god" />
                </div>
                <!-- randomize -->
                <div v-if="selectedOpts.god" style="display: flex; flex-direction: column">
                  <label class="vs-input--label mt-2">Randomize</label>
                  <vs-switch v-model="selectedOpts.randomize" label="Randomize" class="mt-3" />
                </div>
                <!-- ask for music -->
                <label class="vs-input--label mt-2" v-if="selectedOpts.god">Select music</label>
                <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.god">
                  <multiselect
                    v-model="selectedOpts.music"
                    placeholder="Select music"
                    label="title"
                    track-by="_id"
                    :options="fetchedMusics"
                    :multiple="false"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('music')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.music"
                  />
                </div>
              </div>
              <!-- combo-4-promoted-items -->
              <div v-if="data.type === 'promoted-items'">
                <!-- ask for items -->
                <label class="vs-input--label mt-3">Select promoted item</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.promotedItem"
                    placeholder="Select promoted item"
                    label="title"
                    track-by="_id"
                    :options="fetchedPromotedItems"
                    :multiple="false"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('promotedItem')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.promotedItem"
                  />
                </div>
              </div>
              <!-- combo-5-festivals -->
              <div v-if="data.type === 'festivals'">
                <!-- ask for today festival or false-->
                <label class="vs-input--label mt-2">Today's festival?</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <vs-switch v-model="todayFestival" label="Today's festival?" class="mt-3" @input="fetchFestivals()" />
                </div>
                <!-- ask for festivals -->
                <label class="vs-input--label mt-3">Select festival</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.festival"
                    placeholder="Select festival"
                    label="name"
                    track-by="_id"
                    :options="fetchedFestivals"
                    :multiple="false"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('festival')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.festival"
                  />
                </div>
              </div>
              <!-- combo-6-holiday -->
              <div v-if="data.type === 'holiday'">
                <!-- ask for today holiday or false-->
                <label class="vs-input--label mt-2">Today's holiday?</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <vs-switch v-model="todayHoliday" label="Today's holiday?" class="mt-3" />
                </div>
                <!-- ask for holiday -->
                <div>
                  <label class="vs-input--label mt-3">Select article category</label>
                  <div style="display: flex; align-items: center; gap: 0.5cm">
                    <multiselect
                      v-model="selectedOpts.articleCat"
                      placeholder="Select article category"
                      label="name"
                      track-by="_id"
                      :options="fetchedArticleCats"
                      :multiple="false"
                      @input="fetchArticlesByCategory($event._id)"
                    />
                    <vs-button
                      icon="clear"
                      color="danger"
                      @click="clearButton('articleCat')"
                      style="border-radius: 50%; z-index: 0"
                      v-if="selectedOpts.articleCat"
                    />
                  </div>
                  <!-- ask for article -->
                  <label class="vs-input--label mt-2" v-if="selectedOpts.articleCat">Select article</label>
                  <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.articleCat">
                    <multiselect
                      v-model="selectedOpts.article"
                      placeholder="Select article"
                      label="name"
                      track-by="_id"
                      :options="fetchedArticles"
                      :multiple="false"
                    />
                    <vs-button
                      icon="clear"
                      color="danger"
                      @click="clearButton('article')"
                      style="border-radius: 50%; z-index: 0"
                      v-if="selectedOpts.article"
                    />
                  </div>
                </div>
              </div>
              <!-- next button to stage 2 -->
              <vs-row vs-justify="end">
                <vs-button icon="arrow_forward" color="primary" @click="handleClick" class="mt-5" style="z-index: 0">
                  {{
                    selectedOpts.dailyStatus ||
                    selectedOpts.post ||
                    selectedOpts.articleCat ||
                    selectedOpts.article ||
                    selectedOpts.god ||
                    selectedOpts.music ||
                    selectedOpts.promotedItem ||
                    data.type
                      ? "Next"
                      : "Skip"
                  }}
                </vs-button>
              </vs-row>
            </vs-col>
            <!-- stage 2 -->
            <vs-col vs-lg="12" vs-xs="12" v-if="stage === 2">
              <!-- default fills -->
              <vs-input v-model="data.title" label="Title*" class="mt-3" />
              <vs-textarea v-model="data.message" label="Message*" />
              <vs-col v-if="displayImage">
                <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                <b v-if="$data.fileName">File Name : {{ $data.fileName }}</b>
                <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
              </vs-col>
              <div class="upload-btn-wrapper vs-input-primary" v-if="displayImage === ''">
                <label class="vs-input--label">Upload Image (Optional)</label>
                <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                <input type="file" ref="fileInput" @change="uploadImage($event)" />
              </div>
              <vs-col vs-lg="12" vs-xs="12">
                <!-- app targets -->
                <label class="vs-input--label" style="margin-top: 0.5cm">Target Apps</label>
                <multiselect
                  v-model="data.targetApps"
                  placeholder="Select target apps"
                  label="title"
                  track-by="_id"
                  :options="fetchedApps"
                  :multiple="true"
                />
                <!-- scheduling -->
                <vs-row vs-align="center">
                  <vs-select v-model="data.cronRun" label="Running schedule" class="mt-3" style="width: 25%" :disabled="!isNew">
                    <vs-select-item value text="Choose schedule" disabled />
                    <vs-select-item :value="item" :text="item" v-for="(item, index) in cronRunOpts" :key="index" />
                  </vs-select>
                  <!-- status -->
                  <div class="ml-4 mt-2">
                    <label class="vs-input--label"
                      >Status:
                      <span v-if="data.status" class="text-success">Active</span>
                      <span v-else class="text-danger">Inactive</span>
                    </label>
                    <vs-switch v-model="data.status" label="Status" class="mt-3" />
                  </div>
                  <!-- notificaton sound -->
                  <div class="ml-4 mt-2">
                    <label class="vs-input--label"
                      >Sound:
                      <span v-if="data.sound" class="text-success">Yes</span>
                      <span v-else class="text-danger">No</span>
                    </label>
                    <vs-switch v-model="data.sound" label="Sound" class="mt-3" />
                  </div>
                  <!-- is-recurring -->
                  <div class="ml-4 mt-2" v-if="data.cronRun === 'custom'">
                    <label class="vs-input--label"
                      >Recurring?:
                      <span v-if="data.isReccuring" class="text-success">Yes</span>
                      <span v-else class="text-danger">No</span>
                    </label>
                    <vs-switch v-model="data.isReccuring" label="Recurring" class="mt-3" />
                  </div>
                  <!-- custom date and time -->
                  <div
                    v-if="data.cronRun === 'custom' && data.frequency !== 'weekly' && data.frequency !== 'daily' && data.cronRun !== 'immediate'"
                    class="mt-3 mr-3"
                  >
                    <label class="vs-input--label">Custom Date</label>
                    <datepicker
                      placeholder="Select Date"
                      v-model="data.customDate"
                      class="mt-1"
                      format="yyyy-MM-dd"
                      input-class="form-group"
                      :open-date="new Date()"
                    >
                    </datepicker>
                  </div>
                  <div v-if="data.cronRun == 'custom' && data.cronRun !== 'immediate'" class="mt-1" style="display: flex; flex-direction: column">
                    <label class="vs-input--label">Custom Time</label>
                    <vue-timepicker
                      class="mt-2"
                      v-model="data.customTime"
                      format="hh A"
                      :hour-range="this.data.frequency === 'daily' && this.allowedHours"
                    />
                  </div>
                  <!-- if recurring ask for frequency -->
                  <vs-select
                    v-if="data.cronRun == 'custom' && data.isReccuring"
                    v-model="data.frequency"
                    label="Frequency"
                    class="ml-3"
                    style="width: 25%"
                  >
                    <vs-select-item value text="Choose frequency" disabled />
                    <vs-select-item :value="item" :text="item" v-for="(item, index) in schedule" :key="index" />
                  </vs-select>
                  <!-- if weekly ask which day -->
                  <vs-select
                    v-if="data.cronRun == 'custom' && data.isReccuring && data.frequency === 'weekly'"
                    label="Repeat every-"
                    class="ml-3"
                    style="width: 25%"
                    v-model="data.weeklyDay"
                  >
                    <vs-select-item value text="Choose frequency" disabled />
                    <vs-select-item :value="item" :text="item" v-for="(item, index) in days" :key="index" />
                  </vs-select>
                  <label v-if="data.frequency === 'daily'" class="mt-2">Set time strictly -> 6AM, 9AM, 12PM, 3PM, 6PM, 9PM</label>
                </vs-row>
                <!-- custom key data -->
                <vs-row vs-align="center">
                  <label class="vs-input--label" style="margin-top: 0.5cm">Custom Key Data: {{ data.customKeyValuePairs.length }}</label>
                  <div
                    style="display: flex; align-items: center; gap: 0.5cm; width: 100%"
                    v-for="(keyValuePair, index) in data.customKeyValuePairs"
                    :key="index"
                  >
                    <vs-input v-model="keyValuePair.key" label="Key" class="mt-3" />
                    <vs-input v-model="keyValuePair.value" label="Value" class="mt-3" />
                    <div style="display: flex; align-items: center; gap: 0.1cm">
                      <vs-button icon="delete" @click="removeCustomKey(index)" color="danger" class="mt-3" style="border-radius: 50%; z-index: 0" />
                    </div>
                  </div>
                  <vs-row vs-align="center" vs-justify="center" v-if="data.customKeyValuePairs.length < 8">
                    <vs-button icon="add" @click="addCustomKey" color="primary" class="mt-3" style="z-index: 1">Add pair</vs-button>
                    <vs-button
                      v-if="data.customKeyValuePairs.length === 0 && !isNew"
                      @click="addDifferentItem"
                      icon="add"
                      color="primary"
                      class="mt-3 ml-3"
                      style="z-index: 1"
                      >Attach different item</vs-button
                    >
                  </vs-row>
                </vs-row>
              </vs-col>
              <vs-col vs-lg="12" vs-xs="12" align="end" class="mt-3" v-if="isNew">
                <vs-button icon="save" color="primary" @click="createEnglish">Save</vs-button>
                <!-- <vs-button icon="save" color="primary" @click="createAndTranslate" class="ml-2">Save and Translate</vs-button> -->
              </vs-col>
              <vs-col vs-lg="10" vs-xs="12" align="end" class="mt-3" v-else>
                <vs-button icon="save" color="primary" @click="updateNotification(true)"> Update One</vs-button>
                <!-- <vs-button icon="save" color="primary" @click="updateNotification(false)" class="ml-2">Update All</vs-button> -->
                <!-- <vs-checkbox class="mt-2" v-model="data.updateTranslations" v-if="!isNew && data.language === 'EN'" label="Update translations"
                  >Update translations</vs-checkbox
                > -->
              </vs-col>
            </vs-col>
          </vs-col>
        </vs-popup>
      </vs-card>
    </vs-col>
    <vs-popup class="holamundo" title="Edit Notification - Attach different item" :active.sync="editingToAdd" style="z-index: 50">
      <vs-row style="height: 400px">
        <vs-col vs-lg="12" vs-xs="12">
          <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
            <!-- combo-1-dailystatus -->
            <div v-if="data.type === 'daily-status'">
              <!-- ask for daily status -->
              <label class="vs-input--label mt-3">Select daily status</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="selectedOpts.dailyStatus"
                  placeholder="Select daily status"
                  label="name"
                  track-by="_id"
                  :options="dailyStatuses"
                  :multiple="false"
                  @input="fetchPostsByCategory($event._id)"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('dailyStatus')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.dailyStatus"
                />
              </div>
              <!-- ask for post -->
              <label class="vs-input--label mt-2" v-if="selectedOpts.dailyStatus">Select post</label>
              <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.dailyStatus">
                <multiselect
                  v-model="selectedOpts.post"
                  placeholder="Select post"
                  label="name"
                  track-by="_id"
                  :options="fetchedPosts"
                  :multiple="false"
                />
                <vs-button icon="clear" color="danger" @click="clearButton('post')" style="border-radius: 50%; z-index: 0" v-if="selectedOpts.post" />
              </div>
            </div>
            <!-- combo-2-article -->
            <div v-if="data.type === 'article'">
              <!-- ask for article category -->
              <label class="vs-input--label mt-3">Select article category</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="selectedOpts.articleCat"
                  placeholder="Select article category"
                  label="name"
                  track-by="_id"
                  :options="fetchedArticleCats"
                  :multiple="false"
                  @input="fetchArticlesByCategory($event._id)"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('articleCat')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.articleCat"
                />
              </div>
              <!-- ask for article -->
              <label class="vs-input--label mt-2" v-if="selectedOpts.articleCat">Select article</label>
              <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.articleCat">
                <multiselect
                  v-model="selectedOpts.article"
                  placeholder="Select article"
                  label="name"
                  track-by="_id"
                  :options="fetchedArticles"
                  :multiple="false"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('article')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.article"
                />
              </div>
            </div>
            <!-- combo-3-music -->
            <div v-if="data.type === 'music'">
              <!-- ask for god -->
              <label class="vs-input--label mt-3">Select god</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="selectedOpts.god"
                  placeholder="Select god"
                  label="name"
                  track-by="_id"
                  :options="fetchedGods"
                  :multiple="false"
                  @input="fetchMusicByGod($event._id)"
                />
                <vs-button icon="clear" color="danger" @click="clearButton('god')" style="border-radius: 50%; z-index: 0" v-if="selectedOpts.god" />
              </div>
              <!-- ask for music -->
              <label class="vs-input--label mt-2" v-if="selectedOpts.god">Select music</label>
              <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.god">
                <multiselect
                  v-model="selectedOpts.music"
                  placeholder="Select music"
                  label="title"
                  track-by="_id"
                  :options="fetchedMusics"
                  :multiple="false"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('music')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.music"
                />
              </div>
            </div>
            <!-- combo-4-promoted-items -->
            <div v-if="data.type === 'promoted-items'">
              <!-- ask for items -->
              <label class="vs-input--label mt-3">Select promoted item</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="selectedOpts.promotedItem"
                  placeholder="Select promoted item"
                  label="title"
                  track-by="_id"
                  :options="fetchedPromotedItems"
                  :multiple="false"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('promotedItem')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.promotedItem"
                />
              </div>
            </div>
            <!-- combo-5-festivals -->
            <div v-if="data.type === 'festivals'">
              <!-- ask for today festival or false-->
              <label class="vs-input--label mt-2">Today's festival?</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <vs-switch v-model="todayFestival" label="Today's festival?" class="mt-3" @input="fetchFestivals()" />
              </div>
              <!-- ask for festivals -->
              <label class="vs-input--label mt-3">Select festival</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <multiselect
                  v-model="selectedOpts.festival"
                  placeholder="Select festival"
                  label="name"
                  track-by="_id"
                  :options="fetchedFestivals"
                  :multiple="false"
                />
                <vs-button
                  icon="clear"
                  color="danger"
                  @click="clearButton('festival')"
                  style="border-radius: 50%; z-index: 0"
                  v-if="selectedOpts.festival"
                />
              </div>
            </div>
            <!-- combo-6-holiday -->
            <div v-if="data.type === 'holiday'">
              <!-- ask for today holiday or false-->
              <label class="vs-input--label mt-2">Today's holiday?</label>
              <div style="display: flex; align-items: center; gap: 0.5cm">
                <vs-switch v-model="todayHoliday" label="Today's holiday?" class="mt-3" />
              </div>
              <!-- ask for holiday -->
              <div>
                <label class="vs-input--label mt-3">Select article category</label>
                <div style="display: flex; align-items: center; gap: 0.5cm">
                  <multiselect
                    v-model="selectedOpts.articleCat"
                    placeholder="Select article category"
                    label="name"
                    track-by="_id"
                    :options="fetchedArticleCats"
                    :multiple="false"
                    @input="fetchArticlesByCategory($event._id)"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('articleCat')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.articleCat"
                  />
                </div>
                <!-- ask for article -->
                <label class="vs-input--label mt-2" v-if="selectedOpts.articleCat">Select article</label>
                <div style="display: flex; align-items: center; gap: 0.5cm" v-if="selectedOpts.articleCat">
                  <multiselect
                    v-model="selectedOpts.article"
                    placeholder="Select article"
                    label="name"
                    track-by="_id"
                    :options="fetchedArticles"
                    :multiple="false"
                  />
                  <vs-button
                    icon="clear"
                    color="danger"
                    @click="clearButton('article')"
                    style="border-radius: 50%; z-index: 0"
                    v-if="selectedOpts.article"
                  />
                </div>
              </div>
            </div>
          </vs-col>
        </vs-col>
        <vs-col vs-lg="1" vs-xs="12" align="end" class="mt-3" style="z-index: 0">
          <vs-button icon="save" color="primary" @click="handleEditDone">Save</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Delete Notification" :active.sync="deletePopup">
      <p>Are you sure you want to delete this notification?</p>
      <div>
        <vs-button icon="delete_forever" class="mr-3" @click="dropNotification(deleteId)">Delete</vs-button>
        <vs-button icon="close" @click="deletePopup = false">Cancel</vs-button>
      </div>
    </vs-popup>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Creating and sending notifications...</p>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import Multiselect from "vue-multiselect";
import Datepicker from "vuejs-datepicker";
import "vue2-datepicker/index.css";
import VueTimepicker, { f } from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";

export default {
  name: "NotificationService",
  components: {
    Multiselect,
    Datepicker,
    VueTimepicker,
  },
  data: () => ({
    notifications: [],
    defaultalert: false,
    stage: 0,
    colorx: "#0D2144",
    isNew: true,
    displayImage: "",
    deletePopup: false,
    editingToAdd: false,
    deleteId: "",
    showLoader: false,
    allowedHours: [6, 9, 12, 15, 18, 21],
    data: {
      title: "",
      message: "",
      image: "",
      targetApps: [],
      cronRun: "",
      customDate: "",
      customTime: "",
      language: "",
      customKeyValuePairs: [{ key: "", value: "" }],
      isReccuring: false,
      status: false,
      sound: false,
      updateTranslations: false,
      type: "",
      frequency: "",
      weeklyDay: "",
    },
    editId: "",
    filter: {
      language: "EN",
      status: 1,
    },
    notificcationTypes: ["daily-status", "article", "promoted-items", "festivals", "music", "panchang", "horoscope", "holiday"],
    todayFestival: false,
    todayHoliday: false,
    fetchedApps: [],
    dailyStatuses: [],
    fetchedPosts: [],
    fetchedArticleCats: [],
    fetchedArticles: [],
    fetchedGods: [],
    fetchedMusics: [],
    fetchedPromotedItems: [],
    fetchedFestivals: [],
    prevArticles: [],
    languages: [],
    selectedOpts: {
      selectLatest: null,
      randomize: null,
      dailyStatus: null,
      post: null,
      articleCat: null,
      article: null,
      god: null,
      music: null,
      promotedItem: null,
    },
    cronRunOpts: ["custom", "immediate"],
    schedule: ["daily", "weekly", "monthly", "yearly"],
    days: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
  }),
  watch: {
    schedule: function (val) {
      if (val) {
        if (this.data.frequency === "daily") {
          this.data.customTime = "6 AM";
        }
      }
    },
    todayHoliday: function (val) {
      if (val) {
        if (this.fetchedArticles.length > 0) {
          const today = new Date().toISOString().split("T")[0];
          this.prevArticles = this.fetchedArticles;
          this.fetchedArticles = this.fetchedArticles.filter((article) => article.publishDate.split("T")[0] === today);
        }
      } else {
        this.fetchedArticles = this.prevArticles;
      }
    },
    selectedOpts: {
      handler: function (val) {
        if (val.selectLatest) {
          if (this.selectedOpts.dailyStatus) {
            const latestPost = this.fetchedPosts.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
            this.selectedOpts.post = latestPost;
          } else if (this.selectedOpts.articleCat) {
            const latestArticle = this.fetchedArticles.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
            this.selectedOpts.article = latestArticle;
          }
        }
        if (val.randomize) {
          if (this.selectedOpts.god) {
            this.selectedOpts.music = this.fetchedMusics[Math.floor(Math.random() * this.fetchedMusics.length)];
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    addNew() {
      this.defaultalert = true;
      this.stage = 1;
      this.isNew = true;
      this.displayImage = "";
      this.editId = "";
      this.data = {
        title: "",
        message: "",
        image: "",
        targetApps: [],
        cronRun: "",
        customDate: "",
        customTime: "12 AM",
        language: "EN",
        customKeyValuePairs: [],
        isReccuring: false,
        status: false,
        sound: false,
        updateTranslations: false,
        type: "",
        frequency: "",
        weeklyDay: "",
      };
      this.selectedOpts = {
        dailyStatus: null,
        post: null,
        articleCat: null,
        article: null,
        god: null,
        music: null,
        promotedItem: null,
      };
    },

    editingItem(item) {
      this.defaultalert = true;
      this.stage = 2;
      this.isNew = false;
      this.displayImage = item.image;
      this.data = {
        title: item.title,
        message: item.message,
        image: item.image,
        targetApps: item.targetApps,
        cronRun: item.cronRun,
        customDate: item.customDate,
        customTime: item.customTime ? item.customTime : "12 AM",
        language: item.language,
        customKeyValuePairs: item.customKeyValuePairs,
        isReccuring: item.isReccuring,
        status: item.status,
        sound: item.sound,
        frequency: item.frequency,
        type: item.type,
        weeklyDay: item.weeklyDay,
      };
      this.editId = item._id;
    },

    addDifferentItem() {
      this.editingToAdd = true;
      switch (this.$data.data.type) {
        case "daily-status":
          this.fetchAllCategory();
          break;
        case "article":
          this.fetchAllArticleCategory();
          break;
        case "music":
          this.fetchAllGods();
          break;
        case "promoted-items":
          this.fetchPromotedItems();
          break;
        case "festivals":
          this.fetchFestivals();
          break;
        case "holiday":
          this.fetchAllArticleCategory();
          break;
      }
    },

    handleEditDone() {
      this.editingToAdd = false;

      this.handleClick();
    },

    clearButton(key) {
      this.$data.selectedOpts[key] = null;
      if (this.selectedOpts.selectLatest) {
        this.selectedOpts.selectLatest = false;
      }
    },

    handleClick() {
      const mapSelectedToData = {
        dailyStatus: this.selectedOpts.dailyStatus,
        post: this.selectedOpts.post,
        articleCat: this.selectedOpts.articleCat,
        article: this.selectedOpts.article,
        god: this.selectedOpts.god,
        music: this.selectedOpts.music,
        promotedItem: this.selectedOpts.promotedItem,
        festival: this.selectedOpts.festival,
      };

      const prefills = {
        panchang: `Check out today’s Panchang`,
        horoscope: `Check out today’s Horoscope`,
      };

      switch (this.data.type) {
        case "daily-status":
          this.data.customKeyValuePairs.push({ key: "type", value: "trendingStatus" }, { key: "postId", value: mapSelectedToData.post._id });
          this.data.title = mapSelectedToData.post.name;
          break;
        case "panchang":
          this.data.customKeyValuePairs.push({ key: "type", value: "panchang" }, { key: "date", value: new Date().toISOString() });
          this.data.message = prefills.panchang;
          break;
        case "horoscope":
          this.data.customKeyValuePairs.push({ key: "type", value: "horoscope" }, { key: "date", value: new Date().toISOString() });
          this.data.message = prefills.horoscope;
          break;
        case "article":
          this.data.customKeyValuePairs.push({ key: "type", value: "article" }, { key: "articleId", value: mapSelectedToData.article._id });
          this.data.title = mapSelectedToData.article.name ? mapSelectedToData.article.name : mapSelectedToData.article.title;
          break;
        case "festivals":
          if (this.todayFestival) {
            this.data.customKeyValuePairs.push(
              { key: "type", value: "todayFestival" },
              { key: "festivalId", value: mapSelectedToData.festival._id },
              { key: "festivalToday", value: true }
            );
          } else {
            this.data.customKeyValuePairs.push({ key: "type", value: "upcomingFestival" }, { key: "festivalToday", value: false });
          }
          this.data.title = mapSelectedToData.festival.name;
          break;
        case "music":
          this.data.customKeyValuePairs.push({ key: "type", value: "music" }, { key: "musicId", value: mapSelectedToData.music._id });
          this.data.title = mapSelectedToData.music.title;
          break;
        case "promoted-items":
          this.data.customKeyValuePairs.push({ key: "type", value: "affilaite" }, { key: "link", value: mapSelectedToData.promotedItem.link });
          this.data.title = `Check out this amazing product! ${mapSelectedToData.promotedItem.title.slice(0, 20)}...`;
          break;
        case "holiday":
          if (this.todayHoliday) {
            this.data.customKeyValuePairs.push(
              { key: "type", value: "todayHoliday" },
              { key: "holidayId", value: mapSelectedToData.article._id },
              { key: "holidayToday", value: true }
            );
          } else {
            this.data.customKeyValuePairs.push({ key: "type", value: "upcomingHoliday" }, { key: "holidayToday", value: false });
          }
          this.data.title = `Today's holiday -` + mapSelectedToData.article.name ? mapSelectedToData.article.name : mapSelectedToData.article.title;
          break;
      }

      this.stage = 2;
    },

    async handleFetch(type) {
      if (type === "daily-status") {
        this.fetchAllCategory();
      }
      if (type === "article") {
        this.fetchAllArticleCategory();
      }
      if (type === "music") {
        this.fetchAllGods();
      }
      if (type === "promoted-items") {
        this.fetchPromotedItems();
      }
      if (type === "festivals") {
        this.fetchFestivals();
      }
      if (type === "holiday") {
        if (this.selectedOpts.articleCat) {
          this.selectedOpts.articleCat = null;
          if (this.selectedOpts.article) {
            this.selectedOpts.article = null;
          }
        }
        this.fetchAllArticleCategory();
      }
    },

    handleBackClick() {
      this.stage = 1;
      this.data = {
        title: "",
        message: "",
        image: "",
        targetApps: [],
        cronRun: "custom",
        customDate: "",
        customTime: "",
        language: "EN",
        customKeyValuePairs: [],
        isReccuring: false,
        status: false,
        sound: false,
        frequency: "",
        type: "",
        weeklyDay: "",
      };
      this.selectedOpts = {
        dailyStatus: null,
        post: null,
        articleCat: null,
        article: null,
        god: null,
        music: null,
        promotedItem: null,
      };
      this.todayFestival = false;
      this.displayImage = "";
    },

    addCustomKey() {
      this.data.customKeyValuePairs.push({ key: "", value: "" });
    },

    removeCustomKey(index) {
      this.data.customKeyValuePairs.splice(index, 1);
      this.$vs.notify({
        title: "Success",
        text: "Key-Value pair removed",
        color: "success",
        position: "top-right",
        duration: 2000,
      });
    },

    async deleteImage() {
      this.$data.displayImage = "";
      this.$data.fileName = "";
    },

    resetData() {
      this.filter = {
        language: "EN",
        status: 1,
      };
      this.fetchAllNotifications();
    },

    // main
    async createEnglish() {
      if (this.data.title.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Title is required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.message.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Message is required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.targetApps.length === 0) {
        this.$vs.notify({
          title: "Error",
          text: "Select at least one target app",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.cronRun === "") {
        this.$vs.notify({
          title: "Error",
          text: "Select a schedule",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (
        this.data.cronRun === "custom" &&
        this.data.frequency !== "weekly" &&
        (this.data.frequency === "daily" ? this.data.customTime === "" : this.data.customDate === "" || this.data.customTime === "")
      ) {
        this.$vs.notify({
          title: "Error",
          text: "Select a custom date and time",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.isReccuring && !this.data.frequency) {
        this.$vs.notify({
          title: "Error",
          text: "Select a frequency",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.frequency === "weekly" && this.data.weeklyDay === "") {
        this.$vs.notify({
          title: "Error",
          text: "Select a day for weekly notification",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.frequency === "daily" && !this.allowedHours.includes(parseInt(this.data.customTime.split(" ")[0]))) {
        this.$vs.notify({
          title: "Error",
          text: "Select a valid time for daily notification",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      const FormData = {
        title: this.data.title,
        message: this.data.message,
        image: this.displayImage,
        targetApps: this.data.targetApps,
        cronRun: this.data.cronRun,
        language: this.data.language,
        customKeyValuePairs: this.data.customKeyValuePairs,
        isReccuring: this.data.isReccuring,
        status: this.data.status,
        sound: this.data.sound,
        type: this.data.type,
      };

      if (this.data.cronRun === "custom") {
        FormData.customDate = this.data.customDate;
        FormData.customTime = this.data.customTime;
      }

      if (this.data.isReccuring) {
        FormData.frequency = this.data.frequency;
        if (this.data.isReccuring && this.data.frequency === "weekly" && this.data.weeklyDay) {
          FormData.weeklyDay = this.data.weeklyDay;
        }
      }
      try {
        if (this.data.cronRun !== "immediate") {
          this.$vs.loading();
        }
        if (FormData.cronRun === "immediate") {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "",
            text: "Notification are being sent in background",
            position: "top-right",
          });
          this.showLoader = true;
          this.defaultalert = false;
        }

        const res = await api.post(API.GET_NOTIFICATIONS, FormData, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Notification created",
            color: "success",
            position: "top-right",
          });
          this.defaultalert = false;
          this.fetchAllNotifications();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async createAndTranslate() {
      if (this.data.title.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Title is required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.message.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Message is required",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.targetApps.length === 0) {
        this.$vs.notify({
          title: "Error",
          text: "Select at least one target app",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.cronRun === "") {
        this.$vs.notify({
          title: "Error",
          text: "Select a schedule",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.cronRun === "custom" && this.data.frequency !== "weekly" && (this.data.customDate === "" || this.data.customTime === "")) {
        this.$vs.notify({
          title: "Error",
          text: "Select a custom date and time",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.isReccuring && !this.data.frequency) {
        this.$vs.notify({
          title: "Error",
          text: "Select a frequency",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.frequency === "weekly" && this.data.weeklyDay === "") {
        this.$vs.notify({
          title: "Error",
          text: "Select a day for weekly notification",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.frequency === "daily" && !this.allowedHours.includes(parseInt(this.data.customTime.split(" ")[0]))) {
        this.$vs.notify({
          title: "Error",
          text: "Select a valid time for daily notification",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      const FormData = {
        title: this.data.title,
        message: this.data.message,
        image: this.displayImage,
        targetApps: this.data.targetApps,
        cronRun: this.data.cronRun,
        language: this.data.language,
        customKeyValuePairs: this.data.customKeyValuePairs,
        isReccuring: this.data.isReccuring,
        status: this.data.status,
        sound: this.data.sound,
        type: this.data.type,
      };

      if (this.data.cronRun === "custom") {
        FormData.customDate = this.data.customDate;
        FormData.customTime = this.data.customTime;
      }

      if (this.data.isReccuring) {
        FormData.frequency = this.data.frequency;
        if (this.data.isReccuring && this.data.frequency === "weekly" && this.data.weeklyDay) {
          FormData.weeklyDay = this.data.weeklyDay;
        }
      }
      try {
        if (this.data.cronRun !== "immediate") {
          this.$vs.loading();
        }
        if (FormData.cronRun === "immediate") {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "",
            text: "Notification are being sent in background",
            position: "top-right",
          });
          this.showLoader = true;
          this.defaultalert = false;
        }

        const res = await api.post(API.C_AND_T_NOTIFICATION, FormData, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Notification created",
            color: "success",
            position: "top-right",
          });
          this.defaultalert = false;
          this.fetchAllNotifications();
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async updateNotification(isOne) {
      if (this.data.isReccuring && !this.data.frequency) {
        this.$vs.notify({
          title: "Error",
          text: "Either select a frequency or uncheck recurring",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (this.data.title.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Cannot update without title",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (this.data.message.trim() === "") {
        this.$vs.notify({
          title: "Error",
          text: "Cannot update without message",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.data.frequency === "weekly" && (this.data.weeklyDay === "" || !this.data.weeklyDay)) {
        this.$vs.notify({
          title: "Error",
          text: "Cannot update without weekly day",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      try {
        this.$vs.loading();
        const FormData = {
          title: this.data.title,
          message: this.data.message,
          image: this.displayImage,
          targetApps: this.data.targetApps,
          cronRun: this.data.cronRun,
          language: this.data.language,
          customKeyValuePairs: this.data.customKeyValuePairs,
          isReccuring: this.data.isReccuring,
          status: this.data.status,
          sound: this.data.sound,
          type: this.data.type,
        };

        if (this.data.cronRun === "custom") {
          FormData.customDate = this.data.customDate;
          FormData.customTime = this.data.customTime;
        }
        if (this.data.isReccuring) {
          FormData.frequency = this.data.frequency;
          if (this.data.isReccuring && this.data.frequency === "weekly" && this.data.weeklyDay) {
            FormData.weeklyDay = this.data.weeklyDay;
          }
        }
        if (this.data.updateTranslations) {
          FormData.updateTranslations = this.data.updateTranslations;
        }
        if (isOne) {
          FormData.isOne = isOne;
        }

        const res = await api.put(`${API.GET_NOTIFICATIONS}/${this.editId}`, FormData, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Notification updated",
            color: "success",
            position: "top-right",
          });
          (this.editId = ""), (this.defaultalert = false);
          this.fetchAllNotifications();
          if (this.$route.query.id) {
            this.$router.push({ path: "/calendar" });
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllNotifications() {
      try {
        this.$vs.loading();
        const res = await api.get(`${API.GET_NOTIFICATIONS}/?language=${this.filter.language}&status=${this.filter.status}`);
        const targetId = this.$route.query.id;
        const targetItem = res.data.find((item) => item._id === targetId);

        if (targetItem) {
          this.editingItem(targetItem, "edit");
        }
        if (res.status == 200) {
          this.notifications = res.data;
        } else {
          this.$vs.notify({
            title: "Error",
            text: res.data.error,
            color: "danger",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async dropNotification(id) {
      try {
        this.$vs.loading();
        const res = await api.delete(`${API.GET_NOTIFICATIONS}/${id}`);
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Notification deleted",
            color: "success",
            position: "top-right",
          });
          this.fetchAllNotifications();
          this.deletePopup = false;
          this.deleteId = "";
        } else {
          this.$vs.notify({
            title: "Error",
            text: res.data.error,
            color: "danger",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAgainUsingLanguage(lang) {
      try {
        if (!this.editId) return;
        const res = await api.get(`${API.GET_NOTIFICATIONS}/${this.editId}&language=${lang}`);
        if (res.status == 200) {
          this.$data.data = { ...res.data };
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("app", this.$data.data.title);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      try {
        this.$vs.loading();
        const response = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (response.status === 200) {
          this.$data.displayImage = response.data.files[0].url;
          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });
        }
      } catch (error) {
        this.$vs.notify({
          text: "File Uploading Failed",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        this.$refs.fileInput.value = null;
      }
    },

    async fetchAllLanguages() {
      try {
        this.$vs.loading();
        const res = await api.get(API.GET_LANG, {});
        if (res.status == 200) {
          this.$data.languages = res.data;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllApps(lang) {
      try {
        this.$vs.loading();
        const res = await api.get(`${API.GET_APP}?language=${lang}`);
        if (res.status == 200) {
          this.$data.fetchedApps = res.data;
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: error,
          color: "danger",
          position: "top-right",
        });
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllCategory() {
      this.$vs.loading();
      const res = await api.get(`${API.GET_CAT}/plain?language=${this.data.language}&sort=${this.filter.sortBy}&status=1`);
      try {
        if (res.status == 200) this.$data.dailyStatuses = res.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchPostsByCategory(category) {
      if (!category) return;
      if (this.selectedOpts.selectLatest) this.selectedOpts.selectLatest = false;

      this.selectedOpts.post = null;
      this.$vs.loading();
      const res = await api.get(
        `${API.GET_ALL_POST_BY_CAT_GUID}?catId=${category}&language=${this.data.language}&sort=${this.filter.sortBy}&status=1`
      );
      try {
        if (res.status == 200) this.$data.fetchedPosts = res.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllGods() {
      this.$vs.loading();

      const res = await api.get(`${API.GET_GOD}?language=${this.data.language}&sort=${this.filter.sortBy}`);
      try {
        if (res.status == 200) this.$data.fetchedGods = res.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchMusicByGod(god) {
      if (!god) return;
      this.selectedOpts.music = null;
      this.$vs.loading();
      const res = await api.get(`${API.GET_MUSIC}?god=${god}&language=${this.data.language}&sort=${this.filter.sortBy}`);
      try {
        if (res.status == 200) this.$data.fetchedMusics = res.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllArticleCategory() {
      this.$vs.loading();
      const res = await api.get(`${API.ARTICLE_CATEGORY}/plain`, {});
      try {
        if (res.status == 200) this.$data.fetchedArticleCats = res.data.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchArticlesByCategory(category) {
      if (!category) return;
      if (this.selectedOpts.selectLatest) this.selectedOpts.selectLatest = false;

      this.selectedOpts.article = null;
      this.$vs.loading();
      const res = await api.get(
        `${API.ARTICLE}/plain?articlecategory=${category}&language=${this.data.language}&sort=${this.filter.sortBy}&status=true`
      );
      try {
        if (res.status == 200) this.$data.fetchedArticles = res.data.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchPromotedItems() {
      this.$vs.loading();
      const res = await api.get(`https://api.exaweb.in:5200/affiliate/allItems`);
      try {
        if (res.status == 200) this.$data.fetchedPromotedItems = res.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchFestivals() {
      this.$vs.loading();
      let today = this.todayFestival ? 1 : 0;

      const res = await api.get(`${API.FESTIVAL}?today=${today}&status=1`);
      try {
        if (res.status == 200) this.$data.fetchedFestivals = res.data.data;
      } catch (error) {
        throw error;
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  async mounted() {
    await Promise.all([this.fetchAllLanguages(), this.fetchAllNotifications(), this.fetchAllApps(this.filter.language)]);
    if (this.$route.query.language) {
      this.filter.language = this.$route.query.language;
    }
  },
};
</script>

<style scoped>
.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.sub-text {
  color: red;
}

.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
